import React from 'react';
import SputnikGame from '../../features/apps/components/SputnikGame';

const SputnikGameRoute = () => {
  return <SputnikGame />;
};

export default SputnikGameRoute;
